"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddress = void 0;
const hw_app_btc_1 = __importDefault(require("@ledgerhq/hw-app-btc"));
const logs_1 = require("@ledgerhq/logs");
const derivation_1 = require("@ledgerhq/coin-framework/derivation");
const errors_1 = require("../../errors");
const getAddress = (transport, { currency, path, verify, derivationMode, forceFormat }) => __awaiter(void 0, void 0, void 0, function* () {
    const format = forceFormat || (0, derivation_1.getAddressFormatDerivationMode)(derivationMode);
    const btc = new hw_app_btc_1.default({ transport, currency: currency.id });
    let result;
    try {
        result = yield btc.getWalletPublicKey(path, {
            verify,
            format: format,
        });
    }
    catch (e) {
        // TODO Should normalize error returned from ledgerjs
        if (e &&
            e.message &&
            (e.message.includes("invalid format") || e.message.includes("Unsupported address format"))) {
            throw new errors_1.UnsupportedDerivation();
        }
        throw e;
    }
    const { bitcoinAddress, publicKey, chainCode } = result;
    (0, logs_1.log)("hw", `getAddress ${currency.id} path=${path} address=${bitcoinAddress} publicKey=${publicKey} chainCode=${chainCode}`);
    return {
        address: bitcoinAddress,
        path,
        publicKey,
        chainCode,
    };
});
exports.getAddress = getAddress;
const resolver = (transport, opts) => (0, exports.getAddress)(transport, opts);
exports.default = resolver;
//# sourceMappingURL=hw-getAddress.js.map